"use client";

import { useState } from "react";
import { X } from "lucide-react";

import { useStyles } from "./styles";
import { Alert as TAlert } from "@/types/alert";
import { useAppSelector, useAppDispatch } from "@/redux/store";
import { removeAlert } from "@/redux/actions";

interface AlertProps {
  alert: TAlert;
  onRemove: (id: string) => void;
}

const Alert: React.FC<AlertProps> = ({ alert, onRemove }) => {
  const { classes, cx } = useStyles();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className={classes.alert}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={classes.alertContent}>
        <span>{alert.text}</span>
        <X
          className={cx(classes.closeButton, isHovered && classes.show)}
          onClick={() => onRemove(alert.id)}
          size={12}
        />
      </div>
    </div>
  );
};

const Alerts = () => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const alerts = useAppSelector((state) => state.alert.alerts);

  return (
    <div className={classes.container}>
      {alerts.length > 0 &&
        alerts.map((alert) => {
          const handleRemove = (id: string) => {
            dispatch(removeAlert(id));
          };

          return <Alert key={alert.id} alert={alert} onRemove={handleRemove} />;
        })}
    </div>
  );
};

export default Alerts;
